module.exports = __webpack_public_path__ + "img/edit-icon.c0240502.png";